module.exports = __webpack_public_path__ + "img/icon_65.830f55bd.png";